import {MessageCodes} from "../MessageCodes";
import ResultText from "../ResultText";
import CheckCSName from "../../CheckCSName";
import EmptyLine from "../../EmptyLine";
import ResultTable from "../../Table/ResultTable";
import ResultHeader from "../../Table/ResultHeader";
import ResultRow from "../../Table/ResultRow";
import ResultHeaderCell from "../../Table/ResultHeaderCell";
import ResultBody from "../../Table/ResultBody";
import ResultBodyCell from "../../Table/ResultBodyCell";
import {useUser} from "../../../Context/UserContext";
import HecRasHelper from "../../../Helpers/HecRasHelper";
import ResultView from "../../V2/ResultView";

export function B31({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const Description = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Internal.SCRSXY13.error_id: {
            return (
                <>
                    <ResultText>
                        Schematic Channel DS Reach Length could not be calculated accurately for the following cross sections because the cutline of the DS cross section does not intersect the stream centerline.
                        <EmptyLine />
                    </ResultText>
                    <ResultText>
                        <CheckCSName csNameList={row?.data?.map(r => r.cross_section)} />
                    </ResultText>
                </>
            )
        }
        case MessageCodes.Internal.SCRS01.error_id: {
            return (
                <>
                    <ResultText>
                        There are differences at River Stationing between Assigned and Calculated (using the Schematic XY) values. The cross sections with a difference of more than {settings?.thresholds?.rs_diff || '1 ft'} ft are listed in the table below.
                        <EmptyLine />
                    </ResultText>
                    <ResultTable data={row}>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell colSpan={4}>
                                    River Station (ft)
                                </ResultHeaderCell>
                            </ResultRow>
                            <ResultRow>
                                {/*<ResultHeaderCell>River Station</ResultHeaderCell>*/}
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(10), textAlign: 'start'}}>Schematic</ResultHeaderCell>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(10), textAlign: 'start'}}>Assigned</ResultHeaderCell>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(10), textAlign: 'end'}}>Difference</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                row?.data?.map(r => {
                                    return (
                                        <>
                                            <ResultRow>
                                                {/*<ResultBodyCell>{r.cross_section}</ResultBodyCell>*/}
                                                <ResultBodyCell>{r.schematic}</ResultBodyCell>
                                                <ResultBodyCell>
                                                    <CheckCSName csName={r.cross_section} />
                                                </ResultBodyCell>
                                                <ResultBodyCell style={{textAlign: 'right'}}>{r.difference}</ResultBodyCell>
                                            </ResultRow>
                                        </>
                                    )
                                })
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
    }
}